import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { useTheme } from '@mui/material';
import { useState } from 'react';
import { connectWallet } from '@brickken/web3';
import { useTranslation } from 'react-i18next';
import { connectWalletButtonStyles } from './connectWalletCardStyles';

export interface IConnectWalletButtonProps {
  isNavbar?: boolean;
}

export const ConnectWalletButton = ({
  isNavbar
}: IConnectWalletButtonProps) => {
  const theme = useTheme();
  const classes = connectWalletButtonStyles(theme, isNavbar);
  const { t } = useTranslation();

  const [isDisabled, setIsDisabled] = useState(false);

  const handleConnectWallet = async () => {
    setIsDisabled(true);
    await connectWallet();
  };

  return (
    <Button
      disabled={isDisabled}
      variant='outlined'
      sx={classes.buttonConnect}
      onClick={handleConnectWallet}
    >
      <Typography>{t('vesting.connect_wallet.button')}</Typography>
      <Icon
        className='walletIcon'
        sx={{
          ml: 0.75,
          '& svg': { fontSize: '24px' }
        }}
      >
        <AccountBalanceWalletIcon />
      </Icon>
    </Button>
  );
};
